import { useEffect } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useDataFetchingClient } from 'data-fetching-client';
import { useDispatch } from 'react-redux';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GET_CHECKOUT_SESSION } from '../data/queries';
import { PENDING, SUBMITTED } from '../constants/Statuses';
import { isBnpl } from '../utils/paymentMethods';
import BuyerOverridesActionTypes from '../state/BuyerOverrides/actionTypes';
import { setTaxCalculationId } from '../state/calculateTaxSlice';
import { jsx as _jsx } from "react/jsx-runtime";
export const BNPL_PAYMENT_METHOD_STORAGE_KEY = 'paymentsUiBnplPaymentMethod';
const BNPL_BUYER_OVERRIDES_STORAGE_KEY = 'paymentsUiBnplBuyerOverrides';
export const setBnplInSessionStorage = paymentMethod => {
  sessionStorage.setItem(BNPL_PAYMENT_METHOD_STORAGE_KEY, paymentMethod);
};
export const storeBuyerOverridesForBnpl = buyerOverrides => {
  sessionStorage.setItem(BNPL_BUYER_OVERRIDES_STORAGE_KEY, JSON.stringify(buyerOverrides));
};
const useHandleBnplRedirect = () => {
  const {
    search
  } = useLocation();
  const client = useDataFetchingClient();
  const dispatch = useDispatch();
  useEffect(() => {
    var _checkoutSession$pref;
    const storedPaymentMethod = sessionStorage.getItem(BNPL_PAYMENT_METHOD_STORAGE_KEY);
    if (!storedPaymentMethod || !isBnpl(storedPaymentMethod)) {
      return;
    }
    const params = new URLSearchParams(search);
    const clientSecret = params.get('payment_intent_client_secret');
    const redirectStatus = params.get('redirect_status');
    if (!clientSecret || !redirectStatus) {
      return;
    }
    const getCheckoutSessionData = client.readQuery({
      query: GET_CHECKOUT_SESSION
    });
    const checkoutSession = getCheckoutSessionData === null || getCheckoutSessionData === void 0 ? void 0 : getCheckoutSessionData.checkoutSession;
    if (!checkoutSession) {
      return;
    }
    sessionStorage.removeItem(BNPL_PAYMENT_METHOD_STORAGE_KEY);
    const storedOverridesRaw = sessionStorage.getItem(BNPL_BUYER_OVERRIDES_STORAGE_KEY);
    sessionStorage.removeItem(BNPL_BUYER_OVERRIDES_STORAGE_KEY);
    const email = checkoutSession.customerEmail || ((_checkoutSession$pref = checkoutSession.prefillData) === null || _checkoutSession$pref === void 0 ? void 0 : _checkoutSession$pref.email) || '';

    // Restore buyer overrides for all redirect outcomes. On processing/failure
    // the checkout remains active and needs prices/selections intact to work
    // correctly. On success the subtotals refetch uses the restored state.
    if (storedOverridesRaw) {
      try {
        const storedOverrides = JSON.parse(storedOverridesRaw);
        dispatch({
          type: BuyerOverridesActionTypes.RESTORE_STATE,
          data: {
            quantities: storedOverrides.quantities,
            prices: storedOverrides.prices,
            selections: storedOverrides.selections
          }
        });
        if (storedOverrides.taxCalculationId != null) {
          dispatch(setTaxCalculationId(storedOverrides.taxCalculationId));
        }
      } catch (_unused) {
        // ignore malformed storage
      }
    }
    switch (redirectStatus) {
      case 'succeeded':
        client.writeQuery({
          query: GET_CHECKOUT_SESSION,
          data: {
            checkoutSession: Object.assign({}, checkoutSession, {
              status: SUBMITTED,
              paymentDetails: {
                paymentMethod: {
                  type: storedPaymentMethod
                },
                customer: {
                  email
                }
              }
            })
          }
        });
        break;
      case 'processing':
        client.writeQuery({
          query: GET_CHECKOUT_SESSION,
          data: {
            checkoutSession: Object.assign({}, checkoutSession, {
              status: PENDING,
              paymentDetails: {
                paymentMethod: {
                  type: storedPaymentMethod
                },
                customer: {
                  email
                }
              }
            })
          }
        });
        break;
      default:
        FloatingAlertStore.addAlert({
          id: 'bnpl-redirect-failed',
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.errorAlert.default.title"
          }),
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.errorAlert.default.text"
          }),
          type: 'danger'
        });
        break;
    }
  }, [search, client, dispatch]);
};
export default useHandleBnplRedirect;